import mainTitle from '../../../../../images/mainTitle.png'


export const class_name_first = {
    main_container: 'd-flex',
    container: {
        container: "d-flex flex-column w-100 pt-1 pb-0",
        style: {
            margin: 1,
        }
    },
    header_container: {
        header_container: 'w-100 py-2',
        style:{
            paddingLeft:40,
            margin:1,
        }
    },
    header_container_non_routable: {
        header_container_non_routable: 'd-flex flex-column align-items-center justify-content-start text-white ',
        header_container_non_routable_title: 'font-weight-bold first-class-header-title py-1',
        header_container_non_routable_optional:'fontSize_14 font-light_italic_calibri-family',
    },
    child_container: {
        child_container: "",
        style: {
            margin:1
        }
    },
    child_content_container: {
        child_content_container: '',
        child_content_container_header: '',
        child_content_container_desc: '',
        child_content_container_footer: '',
    }
}

export const class_name_second = {
    main_container: 'd-flex',
    container: {
        container: "w-20 px-1px",
        style: {
            margin: 1,
        }
    },
    header_container: {
        header_container: 'w-100 py-2 mt-1',
        style:{
            paddingLeft:0,
            margin:1,
        }
    },
    header_container_non_routable: {
        header_container_non_routable: 'd-flex flex-row align-items-center justify-content-around text-dark px-1',
        header_container_non_routable_title: 'second-class-header-title font-weight-bold ml-1',
        header_container_non_routable_optional:'',
    },
    child_container: {
        child_container: "d-flex flex-column col-12 flex-wrap w-100 px-0 ",
        style: {
            margin:1
        }
    },
    child_content_container: {
        child_content_container: 'd-flex col-sm-12 col-md-12 col-lg-12 px-2 py-1 mt-1 text-dark',
        child_content_container_header: 'font-weight-bold py-1 landdFont text-left flex_2 d-flex align-items-center min-height-landd',
        child_content_container_desc: 'font-class-compatibility-content px-2 py-1',
        // flex_1
        child_content_container_footer: '',
    }
}

export const data_first = [
    {
        link:'',
        header_background_image: mainTitle,
        header_text:'View team member learning needs by orientation',
        header_sub_text: '(Number indicates how many team members have that attribute in their bottom-5)',
        child_content: [
            
        ]
    } 
]



// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/Category/L&D/LandDData.js